<template>
  <div class="header-container d-flex align-items-center">
    <div class="source-serif flex-grow-1 mx-2 fs-5">
      {{ title }}
    </div>

    <Icon 
      type="delete" 
      class="me-2"
      icon-color="icon-theme-red"
      :active="filterPanelPinned"
      @click="resetFilterSelectionAndRemoveQueryStrings()"
    />

    <Icon 
      type="pin" 
      class="me-2"
      :active="filterPanelPinned"
      @click="toggleFilterPanelPinned()"
    />

    <Icon 
      :type="!filterPanelCollapsed ? 'left' : 'right'" 
      class="me-2"
      @click="toggleFilterPanelCollapsed()"
    />
  </div>
</template>

<script lang="ts">
import { useFilterStore, useUiStore } from '@/store';
import { mapActions, mapState, mapWritableState } from 'pinia';
import { defineComponent } from 'vue';
import Icon from '../common/Icon.vue';

export default defineComponent({
  name: 'FilterPanelHeader',
  components: { Icon },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(useUiStore, {
      filterPanelCollapsed: store => store.filterPanelCollapsed,
      filterPanelPinned: store => store.filterPanelPinned
    }),
    ...mapWritableState(useUiStore, {
      filterPanelPinned: 'filterPanelPinned'
    }),
    ...mapWritableState(useFilterStore, {
      filterFields: 'filterFields'
    }),
  },
  methods: {
    ...mapActions(useUiStore, {
      toggleFilterPanelCollapsed: 'toggleFilterPanelCollapsed'
    }),
    ...mapActions(useFilterStore, {
      resetFilterSelectionAndRemoveQueryStrings: 'resetFilterSelectionAndRemoveQueryStrings'
    }),

    toggleFilterPanelPinned() {
      this.filterPanelPinned = !this.filterPanelPinned
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.header-container {
  height: $panel-header-height;
}
</style>
